/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { InjectionToken } from "@angular/core";

/** A configuration object with environment-specific properties. */
export interface EvironmentConfig {
  /**
   * True if the @angular/core enableProdMode should be called.
   *
   * Presumably, this is true for environmentKey of "stage" and "prod", but this
   * is just to be more explicit about the intentions.
   */
  enableProdMode: boolean;

  /** Key for which environment this is. */
  environmentKey: string;

  /** The api server address/base URL. */
  apiBase: string;

  /** The config server address. */
  configApiBase: string;
}

export const ENVIRONMENT_CONFIG = new InjectionToken<EvironmentConfig>(
  "environment config"
);
